<template>

  <div>
  <el-dialog title="修改" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
    :close-on-press-escape="false">
    <el-form size="small" ref="form" :model="form">
     <el-form-item label="订单号" :label-width="formLabelWidth" :rules="[{ required: true, message: ' ' }]" prop="order_out_no">
         <el-input v-model="form.order_out_no"  placeholder="" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="物流公司" :label-width="formLabelWidth"  :rules="[{ required: true, message: ' ' }]" prop="express_id">
        <el-select v-model="form.express_id" placeholder="请选择快递公司">
          <el-option :label="item.express_name" v-for="(item, index) in expressList" :key="index" :value="item.express_id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="物流单号" :label-width="formLabelWidth"  :rules="[{ required: true, message: ' ' }]" prop="express_no">
        <el-input v-model="form.express_no" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="收货人名字" :label-width="formLabelWidth" :rules="[{ required: true, message: ' ' }]" prop="name">
         <el-input v-model="form.name"  placeholder="" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="收货手机号" :label-width="formLabelWidth" :rules="[{ required: true, message: ' ' }]" prop="phone">
         <el-input v-model="form.phone"  placeholder="" class="max-w460"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible(false)">取 消</el-button>
      <el-button type="primary" @click="editUser" :loading="loading">确 定</el-button>
    </div>
  </el-dialog>
   <!--上传图片组件-->
    <Upload v-if="isupload" :isupload="isupload" :type="type" @returnImgs="returnImgsFunc">上传图片</Upload>
  </div>
</template>

<script>
  import ExpressApi from '@/api/express.js';
  import Upload from '@/components/file/Upload';
  import DataApi from '@/api/data.js';
  export default {
    components: {
      Upload
    },
    data() {
      return {
        /*是否上传图片*/
        isupload: false,
        /*左边长度*/
        formLabelWidth: '120px',
        /*是否显示*/
        loading: false,
        dialogVisible: false,
        /*form表单数据*/
        user:{},
      };
    },
    props: ['open_edit','form'],
    created() {
      this.getExpress();
       this.dialogVisible = this.open_edit;
    },
    methods: {
        /*上传*/
      openUpload(e) {
        this.isupload = true;
      },

      /*获取图片*/
      returnImgsFunc(e) {
        if (e != null && e.length > 0) {
          this.form.image_url = e[0].file_path;
          this.form.image_id = e[0].file_id;
        }
        this.isupload = false;
      },
      getExpress(){
        let self = this;
        DataApi.getExpressList({}, true)
          .then(data => {
            if (data.code == 1) {
              self.expressList = data.data.expressList
            }
          })
          .catch(error => {
          });
      },
      /*修改用户*/
      editUser() {
        let self = this;

        let params = self.form;
        console.log(params)
         self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
              ExpressApi.update(params, true)
                .then(data => {
                  self.loading = false;
                  if (data.code == 1) {
                    self.$message({
                      message: '恭喜你，操作成功',
                      type: 'success'
                    });
                    self.dialogFormVisible(true);
                  }
                })
                .catch(error => {
                  self.loading = false;
                });
          }
        });
        
      },
      showMessage(msg='信息不能为空'){
        this.$message({
            message: msg,
            type: 'warning'
          });
      },
      /*关闭弹窗*/
      dialogFormVisible(e) {
        console.log(e)
        if (e) {
          this.$emit('closeDialog', {
            type: 'success',
            openDialog: false
          })
        } else {
          this.$emit('closeDialog', {
            type: 'error',
            openDialog: false
          })
        }
      },
      /*打开用户弹窗*/
      openUserDialog() {
        this.open_user = true;
      },
      /*关闭用户弹窗*/
      closeUserDialog(e) {
        if (e.type != 'error') {
          this.user = e.params[0];
          console.log(e.params[0])
          this.form.user_id = e.params[0].user_id;
        }
        this.open_user = false;
      },


    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/express/index/dialog/Edit.vue